export class TerrainGridOptions {
    constructor(p) {
        Object.assign(this, p);
    }
    clone() {
        return new TerrainGridOptions(this);
    }
}
TerrainGridOptions.DefaultGridSize = 32;
TerrainGridOptions.DefaultInvertIndices = false;
TerrainGridOptions.DefaultScale = 1;
TerrainGridOptions.Shared = new TerrainGridOptions({
    columns: TerrainGridOptions.DefaultGridSize,
});
export class TerrainGridOptionsBuilder {
    withUvs(flag) {
        this._uvs = flag;
        return this;
    }
    withNormals(flag) {
        this._normals = flag;
        return this;
    }
    withColumns(v) {
        this._cols = v;
        return this;
    }
    withRows(v) {
        this._rows = v;
        return this;
    }
    withInvertIndices(v) {
        this._invertIndices = v;
        return this;
    }
    withInvertYZ(v) {
        this._invertYZ = v;
        return this;
    }
    withScale(x, y) {
        this._sx = x;
        this._sy = y || x;
        return this;
    }
    withOffset(x, y) {
        this._ox = x;
        this._oy = y || x;
        return this;
    }
    withZInitializer(zinit) {
        this._zInitializer = zinit;
        return this;
    }
    withUVInitializer(uvinit) {
        this._uvInitializer = uvinit;
        return this;
    }
    build() {
        return new TerrainGridOptions({
            uvs: this._uvs,
            normals: this._normals,
            columns: this._cols || this._rows,
            rows: this._rows || this._cols,
            sx: this._sx,
            sy: this._sy,
            invertIndices: this._invertIndices,
            invertYZ: this._invertYZ,
            zInitializer: this._zInitializer,
            uvInitializer: this._uvInitializer,
        });
    }
}
export class TerrainNormalizedGridBuilder {
    constructor(options = null) {
        this.withOptions(options);
    }
    withOptions(options) {
        this._o = { ...TerrainGridOptions.Shared, ...options };
        return this;
    }
    build(data, ...params) {
        data = data || {};
        const w = this._o?.columns || TerrainGridOptions.DefaultGridSize;
        const h = this._o?.rows || w;
        const sx = this._o?.sx || TerrainGridOptions.DefaultScale;
        const sy = this._o?.sy || TerrainGridOptions.DefaultScale;
        const ox = this._o?.ox || 0;
        const oy = this._o?.oy || 0;
        const positions = [];
        const indices = [];
        const uvs = this._o?.uvs ? [] : null;
        const normals = this._o?.normals ? [] : null;
        const dx = 1 / (w - 1);
        const dy = 1 / (h - 1);
        const x0 = -0.5 + ox * dx;
        const y0 = 0.5 + oy * dy;
        for (let row = 0; row < h; row++) {
            let v = row == h - 1 ? 1 : row * dy;
            const y = (y0 - v) * sy;
            for (let column = 0; column < w; column++) {
                const u = column == w - 1 ? 1 : column * dx;
                const x = (x0 + u) * sx;
                const z = this._o?.zInitializer ? this._o.zInitializer(column, row, w, h, ...params) : 0;
                if (this._o?.invertYZ)
                    positions.push(x, z, y);
                else
                    positions.push(x, y, z);
                if (uvs) {
                    const uv = this._o?.uvInitializer ? this._o.uvInitializer(column, row, w, h, ...params) : [u, v];
                    uvs.push(...uv);
                }
                if (normals) {
                    if (this._o?.invertYZ)
                        normals.push(0, 1, 0);
                    else
                        normals.push(0, 0, 1);
                }
            }
        }
        const isWEven = w % 2 == 0;
        for (let row = 0; row < h - 1; row++) {
            const indice = isWEven ? row % 2 : 0;
            const offset = row * w;
            for (let col = 0; col < w - 1; col++) {
                const idx1 = offset + col;
                const idx2 = idx1 + w;
                const idx3 = idx2 + 1;
                const idx4 = idx1 + 1;
                if (idx1 % 2 != indice) {
                    if (this._o?.invertIndices) {
                        indices.push(idx1, idx2, idx4, idx2, idx3, idx4);
                    }
                    else {
                        indices.push(idx1, idx4, idx2, idx2, idx4, idx3);
                    }
                }
                else {
                    if (this._o?.invertIndices) {
                        indices.push(idx1, idx2, idx3, idx3, idx4, idx1);
                    }
                    else {
                        indices.push(idx1, idx3, idx2, idx3, idx1, idx4);
                    }
                }
            }
        }
        data.indices = indices;
        data.positions = positions;
        data.uvs = uvs;
        data.normals = normals;
        return data;
    }
}
//# sourceMappingURL=terrain.grid.js.map